export const iconDictionary = {
  info: 'uiInfoCircle',
  warning: 'uiExclamationTriangle',
  danger: 'uiExclamationTriangle',
  success: 'uiCheckCircle',
}

export const spacingDictionary = {
  sm: 8,
  md: 8,
}

export const messageColors = {
  info: 'seaBlue.main',
  warning: 'terracotta.30',
  danger: 'energyRed.45',
  success: 'landGreen.35',
}
